import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { UserFilter as UserFilterModel, UserFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const UserFilter = (props: { filter: UserFilterModel; setFilter: (value: UserFilterModel) => void }) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<UserFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.users.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const roleField = () => {
    const propertyName = pn<UserFilterModel>("roleId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.roles?.find((x) => props.filter.roleId === x.id)}
        options={resource.roles}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.roleId = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {roleField()}
      </Grid>
    </Grid>
  );
};
